import { observer } from 'mobx-react-lite'
import { Box, Button, Typography } from 'shared/ui'
import { MessageField } from 'widgets/MessageField'
import { type ActionsStore } from '../store/ActionsStore'
import styles from './styles.module.scss'

export type IAfterCallModalContentProps = {
  store: ActionsStore
  modalId: string
  editingId: string | null
}

export const AfterCallModalContent = observer(
  ({ store, modalId, editingId }: IAfterCallModalContentProps) => {
    const { messageFieldStore, onCloseModal, onSave, onDelete } = store

    return (
      <Box display={'flex'} flexDirection={'column'}>
        <div className={styles.content}>
          <Typography
            ariaLabel={'SMS message'}
            variant={'text-input-label-small'}
            color={'var(--content-primary-secondary)'}
          >
            SMS message
          </Typography>
          <div className={styles.alertContainer} ref={messageFieldStore.setAlertElement} />
          <MessageField messageFieldStore={messageFieldStore} />
        </div>
        <div className={styles.footer}>
          {editingId && (
            <Button
              typeBtn={'contained'}
              contained={'secondary'}
              intent={'destructive'}
              text={'Delete action'}
              onClick={() => onDelete(modalId, editingId)}
            />
          )}
          <div className={styles.footerRight}>
            <Button
              typeBtn={'contained'}
              text={'Cancel'}
              contained={'secondary'}
              onClick={() => onCloseModal(modalId)}
            />
            <Button
              typeBtn={'contained'}
              text={'Save'}
              disabled={
                (!messageFieldStore.text.trim() && messageFieldStore.attachments.length === 0) ||
                messageFieldStore.loadingAttachment
              }
              onClick={() => onSave(modalId, editingId)}
            />
          </div>
        </div>
      </Box>
    )
  }
)
